import themes from 'src/themes';


const { palette } = themes['nviro'];

const aspectCategoriesStatusMapper = {
  MA: {
    id: 'MA',
    text: 'Muy alto',
    backgroundColor: palette.error.dark,
    textColor: palette.common.white,
    borderColor: palette.error.dark,
  },
  A: {
    id: 'A',
    text: 'Alto',
    backgroundColor: palette.error.main,
    textColor: palette.common.white,
    borderColor: palette.error.main,
  },
  M: {
    id: 'M',
    text: 'Moderado',
    backgroundColor: palette.fauna.secondary.main,
    borderColor: palette.fauna.secondary.main,
    textColor: palette.common.white,
  },
  B: {
    id: 'B',
    text: 'Bajo',
    backgroundColor: palette.flora.primary.main,
    borderColor: palette.flora.primary.main,
    textColor: palette.common.white,
  },
  MB: {
    id: 'MB',
    text: 'Muy bajo',
    backgroundColor: palette.success.main,
    borderColor: palette.success.main,
    textColor: palette.common.white,
  },
  ND: {
    id: 'ND',
    text: 'No determinado',
    backgroundColor: palette.common.gray700,
    borderColor: palette.common.gray700,
    textColor: palette.common.white,
  },
  'N/A': {
    id: 'N/A',
    text: 'No aplica',
    backgroundColor: palette.common.gray600,
    borderColor: palette.common.gray600,
    textColor: palette.common.white,
  },
};

const aspectCategoryStatusPriority = [ 'MA', 'A', 'M', 'B', 'MB', 'ND', 'N/A' ];

const getHighestImpactCategory = impacts => impacts.reduce((acc, val) => {
  const impactCategory = typeof val === 'string' ? val : val?.impactCategoryStatus;
  const currentIndex = aspectCategoryStatusPriority.indexOf(impactCategory);
  const accIndex = aspectCategoryStatusPriority.indexOf(acc);
  return currentIndex < accIndex ? impactCategory : acc;
}, aspectCategoryStatusPriority[aspectCategoryStatusPriority.length - 1]);

const definedCategories = [ ...aspectCategoryStatusPriority ].slice(0, 5).reverse();

const categoryColorsForCharts = definedCategories.map(
  key => aspectCategoriesStatusMapper[key]?.borderColor || 'rgba(158,167,173,1)',
);

const generateRandomSegments = () => {
  const values = [];
  let remaining = 100;

  // Distribuir porcentajes aleatorios
  for (let i = 0; i < categoryColorsForCharts.length - 1; i++) {
    const val = Math.floor(Math.random() * (remaining / 2)) + 5;
    values.push(val);
    remaining -= val;
  }
  values.push(remaining); // lo que queda para el último tramo
  return categoryColorsForCharts.map((color, idx) => ({ color, value: values[idx] }));
};

const generateSegments = values => {
  const totalCount = definedCategories.reduce((acc, idx) => acc + values[idx], 0);
  const percentageValues = definedCategories.reduce((acc, idx) => [ ...acc, (values[idx] / totalCount) * 100 ], []);
  return categoryColorsForCharts.map((color, idx) => ({ color, value: percentageValues[idx] }));
};

const ndSegments = () => categoryColorsForCharts.map((color, idx) => ({ color: '#808080', value: idx === 4 ? 100 : 0 }));

const getConcernLevel = value => {
  if (!value) {
    return 'ND';
  }
  if (value <= 0.2) {
    return 'MA';
  } else if (value > 0.2 && value <= 0.4) {
    return 'A';
  } else if (value > 0.4 && value <= 0.6) {
    return 'M';
  } else if (value > 0.6 && value <= 0.8) {
    return 'B';
  } else if (value > 0.8 && value <= 1) {
    return 'MB';
  } else {
    return 'ND';
  }
};

const getColorByConcernLevel = value => {
  const concernLevel = getConcernLevel(value);
  return aspectCategoriesStatusMapper[concernLevel].backgroundColor;
};


export {
  aspectCategoriesStatusMapper,
  aspectCategoryStatusPriority,
  getHighestImpactCategory,
  generateRandomSegments,
  getConcernLevel,
  ndSegments,
  generateSegments,
  getColorByConcernLevel,
};
